import type { SignInPending } from "../useSignInFlow";
import { OAuthProviderButton } from "./OAuthProviderButton";

type Props = {
  providers?: string[];
  onSelect: (provider: string) => void;
  pending: SignInPending;
  disabled?: boolean;
};

// Default to Google only — Microsoft is in the dashboard backlog. When enabled,
// add "microsoft" to the default list (or pass it in from the layout).
export function OAuthButtons({
  providers = ["google"],
  onSelect,
  pending,
  disabled,
}: Props) {
  return (
    <>
      {providers.map((p) => (
        <OAuthProviderButton
          key={p}
          provider={p}
          onClick={() => onSelect(p)}
          pending={pending}
          disabled={disabled}
        />
      ))}
    </>
  );
}
